import React, { useContext } from "react";
import styled from "styled-components";

import languagePack, { languageAction } from "../../Utils/language";
import globalContext from "../../Hooks/globalContext";

const Logo = styled.img`
  width: 180px;
`;

const SideBar = styled.div`
  width: 250px;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.mainColor};
`;

const LogoWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 10px 10px;
  font-size: 32px;
  color: white;
  font-weight: bold;
`;

const MenuItem = styled.div`
  width: 100%;
  padding: 15px;
  color: white;
  font-size: 15px;
  cursor: pointer;
  :hover {
    opacity: 0.35;
  }
`;

const FocusedMenuItem = styled(MenuItem)`
  opacity: 0.35;
`;

const LanguageSelect = styled.select`
  position: absolute;
  width: 250px;
  bottom: 0px;
`;

const AdminSideBar = ({ page }) => {
  const { user, language } = useContext(globalContext);

  const selectOnChange = ({ target: { value } }) => {
    language.setState(value);
  };

  const MenuFactory = ({ text = "None", pageName = null }) => {
    const menuOnClick = () => {
      page.setState(pageName);
    };
    return page.state === pageName ? (
      <FocusedMenuItem onClick={menuOnClick}>{text}</FocusedMenuItem>
    ) : (
      <MenuItem onClick={menuOnClick}>{text}</MenuItem>
    );
  };

  return (
    <SideBar>
      <LogoWrapper>LCM WALLET</LogoWrapper>
      <MenuFactory pageName={"userList"} text={"유저 관리"} />
      <MenuFactory pageName={"lockupList"} text={"락업 로그"} />
      <MenuFactory pageName={"stakingList"} text={"스테이킹 로그"} />
      <MenuFactory pageName={"mallList"} text={"마켓 관리"} />
      <MenuFactory pageName={"mallOrder"} text={"마켓 주문 관리"} />
      <MenuFactory pageName={"config"} text={"설정"} />
      <MenuFactory pageName={"excelLockup"} text={"엑셀 락업"} />

      {/* <LanguageSelect onChange={selectOnChange}>
        <option value="english">{languageAction("영어", language.state)}</option>
        <option value="korean">{languageAction("한국어", language.state)}</option>
      </LanguageSelect> */}
    </SideBar>
  );
};

export default AdminSideBar;
